import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form", "title", "button"]

  connect() {
    this.updateTexts()
    this.updateFormVisibility()
  }

  hideServiceDetails() {
    const form = this.element.querySelector('form')
    if (form) {
      const withServiceInput = form.querySelector('input[name*="[with_service_details]"]')

      if (withServiceInput.value === "true") {
        withServiceInput.value = "false"
      } else {
        withServiceInput.value = "true"
      }
      
      this.updateTexts()
      this.updateFormVisibility()
    }
  }

  updateTexts() {
    const withServiceInput = this.element.querySelector('input[name*="[with_service_details]"]')
    const title = this.element.querySelector('h3.text-forest-500')
    const subtitle = this.element.querySelector('p.text-forest-500')
    const button = this.element.querySelector('button')

    if (withServiceInput && withServiceInput.value === "false") {
      if (title) title.textContent = "Show Service Details?"
      if (subtitle) subtitle.textContent = "Your service details are currently hidden. You can click the button below to show them on your tributes page."
      if (button) button.textContent = "Show all service details"
    } else {
      if (title) title.textContent = "Not Having a Service?"
      if (subtitle) subtitle.textContent = "If you'd rather not include any service details, simply click the button below. You can always change your mind later."
      if (button) button.textContent = "Don't show any service details on my page."
    }
  }

  updateFormVisibility() {
    const withServiceInput = this.element.querySelector('input[name*="[with_service_details]"]')
    const formContainer = this.element.querySelector('[data-onboarding_service_details-target="form"]')
    
    if (formContainer) {
      if (withServiceInput && withServiceInput.value === "false") {
        formContainer.classList.add('opacity-50', 'pointer-events-none')
      } else {
        formContainer.classList.remove('opacity-50', 'pointer-events-none')
      }
    }
  }
}
